exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-rating {\n  display:inline-block;\n  margin-right:3px;\n  cursor:pointer;\n  color:#ccc;\n  font-size: 25px;\n}\n\n.icon-rating:hover {\n  color:#006dcc;\n}\n\n.filled {\n  color:#006dcc;\n}\n\n.label-rating {\n\tfont-size: 15px;\n  color: #003f76;\n  vertical-align: super;\n  padding: 3px;\n  border: 2px solid;\n  border-color: #003f76;\n}\n\n.label-rating-1,\n.label-rating-2 {\n  border-color: #f47920;\n  color: #f47920;\n}\n\n.label-rating-4,\n.label-rating-5 {\n  border-color: #5cb85c;\n  color: #5cb85c;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/start-rating/start-rating.component.css
// module id = ../../../../../src/app/components/utilita/start-rating/start-rating.component.css
// module chunks = main